import _ from 'lodash';
import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ChatIconOutline from 'components/lib/icons/chat_icon_outline';
import ReportDuration from 'components/reporting/report/lib/report_duration';
import Tooltip from 'components/common/tooltip';

class PillList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    _.bindAll(this, 'renderPill', 'renderMenuItem');
  }

  UNSAFE_componentWillMount() {
    this.calculateWidth = _.throttle(() => {
      const element = document.getElementsByClassName(this.props.className)[0];
      if (element) {
        this.setState({ width: element.offsetWidth });
      }
    }, 100);
  }

  componentDidMount() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateWidth);
  }

  render() {
    let maxLength = this.props.items.length;
    if (maxLength * this.props.pillWidth > this.state.width) {
      maxLength = _.floor(this.state.width / this.props.pillWidth) - 1;
    }
    return (
      <div className={this.props.className}>
        {_.take(this.props.items, maxLength).map(this.renderPill)}
        {this.renderAdditionalItems(_.drop(this.props.items, maxLength))}
      </div>
    );
  }

  renderPill(item, index) {
    return <Pill key={`pill-${index}`} className="pillList-pill" onClick={this.props.onClick} {...item} />;
  }

  renderAdditionalItems(items) {
    if (items.length === 0) {
      return null;
    }
    return (
      <div className="pillList-pill pillList-pill-hover">
        + {items.length} more
        <div className="pillList-menu-container">
          <div className="pillList-menu">{items.map(this.renderMenuItem)}</div>
        </div>
      </div>
    );
  }

  renderMenuItem(item, index) {
    return <Pill key={`pill-menu-${index}`} className="pillList-menu-item" onClick={this.props.onClick} {...item} />;
  }
}

export const Pill = props => {
  const classNames = classnames(props.className, { 'pillList-pill-hover': props.clickable });
  return (
    <Tooltip message={props.text} position="top">
      <div className={classNames} onClick={onClick}>
        {props.showIcon && <ChatIconOutline className="pillList-pill-icon" />}
        {props.duration ? (
          <ReportDuration className="pillList-duration" duration={props.duration} simplified />
        ) : (
          <div className="pillList-pill-text">{props.text}</div>
        )}
      </div>
    </Tooltip>
  );

  function onClick() {
    props.clickable && props.onClick(props.clickParams);
  }
};

const PillItem = {
  clickable: PropTypes.bool,
  clickParams: PropTypes.any,
  duration: PropTypes.number,
  text: PropTypes.string,
  showIcon: PropTypes.bool,
};

Pill.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  ...PillItem,
};

PillList.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  pillWidth: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.shape(PillItem)),
};

export default PillList;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/liveboards/charts/pill_list.jsx